import { computed, defineComponent, useContext, useCssModule } from '@nuxtjs/composition-api';
import { useUser } from '~/composables';
import { PRICING_LINK_PLANS } from '~/constants';
export default defineComponent({
    name: 'ThePaywall',
    props: {
        paywall: {
            default: () => ({}),
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const context = useContext();
        const viewport = context.$viewport;
        const user = useUser();
        const links = computed(() => {
            if (viewport.isGreaterThan('mobileWide')) {
                return [PRICING_LINK_PLANS];
            }
            return [PRICING_LINK_PLANS];
        });
        const plans = computed(() => {
            const activePackages = user.info?.activePackages || [];
            const output = [];
            for (const pkg of props.paywall.packages || []) {
                const promoaction = null;
                let isActive = false;
                const labels = [];
                for (const activePkg of activePackages) {
                    if (activePkg.package?.id !== pkg.id) {
                        continue;
                    }
                    labels.push({
                        text: 'Оформлена',
                        type: 'active',
                    });
                    isActive = true;
                }
                const tabs = [];
                for (const price of pkg.prices || []) {
                    tabs.push({
                        comment: price.comment,
                        months: Number(price.months),
                        price: Number(price.price),
                        title: price.name || '',
                        value: String(price.id),
                    });
                }
                for (const promo of pkg.promoactions || []) {
                    if (!promo.showInPackage || !promo.active || Boolean(promo.hasPromocodes)) {
                        continue;
                    }
                    // labels.push({
                    //   text: promo.name || '',
                    //   type: 'promo',
                    // })
                    tabs.push({
                        comment: promo.description,
                        // months: Number(promo.),
                        months: 1,
                        price: Number(promo.startingPrice),
                        title: promo.name || '',
                        value: Math.random().toString(),
                        promo,
                    });
                }
                for (const promo of pkg.userPromoactions || []) {
                    if (!promo.showInPackage || !promo.active) {
                        continue;
                    }
                    // labels.push({
                    //   text: promo.name || '',
                    //   type: 'promo',
                    // })
                    tabs.push({
                        comment: promo.description,
                        // months: Number(promo.),
                        months: 1,
                        price: Number(promo.startingPrice),
                        title: promo.name || '',
                        value: Math.random().toString(),
                        promo,
                    });
                }
                output.push({
                    isActive,
                    subtitle: pkg.description,
                    title: pkg.name || '',
                    labels,
                    tabs,
                    features: {
                        digest: true,
                        pdf: true,
                        congress: true,
                        club: true,
                        education: true,
                        investment: true,
                        ratings: false,
                        online: false,
                        partners: false,
                        ad: false,
                    },
                    pkg,
                    promoaction,
                });
            }
            return output;
        });
        return {
            css,
            links,
            plans,
        };
    },
});
